<template>
  <v-container>
    <v-form class="px-3" ref="form" @submit.prevent="submit">
      <v-card class="mx-auto mt-9 pa-4 my-10" min-width="340px" max-width="500px" outlined>
        <v-snackbar
          v-model="showNotification"
          :timeout="timeout"
          :top="true"
          dark
          :color="color"
        >
          {{ errorMsg }}
        </v-snackbar>
        <div class=" px-4 text-center ">
            <v-icon style="font-size: 4rem">mdi-email-edit</v-icon>
        </div>
        <v-card-title class="justify-center text-h5">Contact Us</v-card-title>
        <v-row class="mx-auto">
          <v-col class="px-8">
            <v-text-field
              v-model="name"
              prepend-icon="mdi-account-circle"
              label="Name"
              :rules="nameRules"
              minlength
            >
              <template v-slot:label> Name </template>
            </v-text-field>
            <v-text-field
              v-model="email"
              prepend-icon="mdi-email"
              label="Email"
              :rules="emailRules"
            />
            <v-select
              v-model="subject"
              :items="subjects"
              item-text="title"
              item-value="title"
              prepend-icon="mdi-format-align-left"
              :rules="inputRules"
            >
              <template v-slot:label> Subject </template>
            </v-select>
            <v-textarea
              v-model="message"
              label="Message"
              prepend-icon="mdi mdi-message-text"
              :rules="messageRules"
            >
              <template v-slot:label> Message </template>
            </v-textarea>
            <div style="width: 100%; margin: 1rem 2rem">
              <div id="captcha-widget-1"></div>
            </div>
          </v-col>
        </v-row>
        <v-card-actions class="justify-center mb-2 mb-4">
          <v-btn
            color="primary"
            :loading="isLoading"
            class="text-capitalize"
            @click="submit"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import contactUsService from "@/libs/contactUsService";

export default {
  name: "ContactUs",
  data() {
    return {
      isLoading: false,
      subjects: [
        { id: 1, title: "Feedback" },
        { id: 2, title: "Others" },
      ],
      inputRules: [(v) => !!v || "This field is required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      nameRules: [
        (v) => !!v || "This field is required",
        (v) =>
          (v && v.length >= 4) || "This field must have atleast 4 characters",
      ],
      messageRules: [
        (v) => !!v || "This field is required",
        (v) =>
          (v && v.length <= 3000) ||
          "This field must be less than 3000 characters",
      ],
      name: "",
      email: "",
      subject: "Feedback",
      message: "",
      errorMsg: "",
      showNotification: false,
      timeout: 2000,
      color: "",
      widget: null,
    };
  },
  mounted() {
    this.intializeReCaptcha();
  },
  beforeUnmount() {
    const el = document.getElementById("captcha-widget-1");
    if (el) {
      el.remove();
    }
    this.resetCaptcha();
  },
  methods: {
    resetCaptcha() {
      if (window.grecaptcha && window.grecaptcha.reset) {
        window.grecaptcha.reset(this.widget);
      }
    },
    captchaExpiredCallback() {
      if (window.grecaptcha) {
        this.resetCaptcha();
        this.intializeReCaptcha();
      }
    },
    intializeReCaptcha() {
      setTimeout(
        function () {
          if (
            typeof window.grecaptcha === "undefined" ||
            typeof window.grecaptcha.render === "undefined"
          ) {
            this.intializeReCaptcha();
          } else {
            this.widget = window.grecaptcha.render("captcha-widget-1", {
              sitekey: process.env.VUE_APP_CAPTCHA_SITE_KEY,
              "expired-callback": this.captchaExpiredCallback,
            });
          }
        }.bind(this),
        100
      );
    },
    submit() {
      if (this.$refs.form.validate()) {
        const captchaAlertMsg = "Please select the captcha.";
        const captcha = window.grecaptcha.getResponse(this.widget);
        if (captcha === "" || captcha === undefined || captcha === null) {
          alert(captchaAlertMsg);
          return;
        }
        this.isLoading = true;
        contactUsService
          .contactUs(this.name, this.email, this.subject, this.message, captcha)
          .then((res) => {
            this.isLoading = false;
            if (res.data.success === true) {
              this.color = "green";
              this.showNotification = true;
              this.errorMsg = "Your message has been sent successfully!";
              this.$refs.form.reset();
            } else {
              if (
                res.data.error &&
                res.data.error.captcha &&
                (res.data.error.captcha.includes("required field") ||
                  res.data.error.captcha.includes("empty values not allowed"))
              ) {
                alert(captchaAlertMsg);
              } else {
                this.color = "red";
                this.showNotification = true;
                this.errorMsg = "Sorry, an error occurred.";
              }
            }
            this.resetCaptcha();
            this.intializeReCaptcha();
          })
          .catch(() => {
            this.color = "red";
            this.showNotification = true;
            this.isLoading = false;
            this.errorMsg = "Sorry, an error occurred.";
            this.resetCaptcha();
            this.intializeReCaptcha();
          });
      }
    },
  },
};
</script>